import { RightTooltip } from 'ui/tooltip';
import { useSendingPlatformsQueryContext } from '../../contexts';
import { SendingPlatform } from '../../constants';
import { pluralResourcesText } from '../../utils';
import { Ul } from './styled';
import { IntegrationCard } from './IntegrationCard';

type EmailIntegrationCardProps = {
  sendingPlatform: SendingPlatform;
};

export const EmailIntegrationCard = ({ sendingPlatform }: EmailIntegrationCardProps) => {
  const { espAccountsBySendingPlatform, hasEspAccounts } = useSendingPlatformsQueryContext();

  const espAccounts = espAccountsBySendingPlatform[sendingPlatform];
  const espAccountsText = pluralResourcesText(espAccounts.length, 'account');

  return (
    <IntegrationCard sendingPlatform={sendingPlatform}>
      <RightTooltip
        tooltipContent={
          hasEspAccounts(sendingPlatform) && (
            <Ul>
              {espAccounts.map(({ binding, id: espAccountId, name: espAccountName }) => (
                <li key={espAccountId}>
                  <span>{espAccountName}</span>
                  <span>(ID {espAccountId})</span>
                  {binding && <span>{binding}</span>}
                </li>
              ))}
            </Ul>
          )
        }
        isEnabled={hasEspAccounts(sendingPlatform)}
        isUnderlined
      >
        {espAccountsText}
      </RightTooltip>
    </IntegrationCard>
  );
};
